package pl.michal_cyran.brand_hub.subpages.freelancing

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaBusinessTime
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.icons.fa.FaGooglePlay
import com.varabyte.kobweb.silk.components.icons.fa.FaScroll
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H6
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.HeroButtonsStyle
import pl.michal_cyran.brand_hub.HeroGridStyle
import pl.michal_cyran.brand_hub.components.widgets.DeviceMockup
import pl.michal_cyran.brand_hub.components.widgets.PrimaryButton
import pl.michal_cyran.brand_hub.components.widgets.SecondaryButton
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUp
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUpScale
import pl.michal_cyran.brand_hub.toSitePalette


@Composable
fun FreelancingHero() {
    val cm = ColorMode.current.toSitePalette()

    SimpleGrid(
        numColumns(base = 1, md = 2),
        HeroGridStyle.toModifier()
    ) {
        VisibilityAware(
            modifier = Modifier.fillMaxWidth()
        ) { isVisible ->
            Column(
                modifier = Modifier.fillMaxWidth()
            ) {
                H6(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 0)
                        .toAttrs()
                ) {
                    Text("Ekspert Kotlin Multiplatform")
                }

                H1(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 120)
                        .toAttrs()
                ) {
                    SpanText(
                        "Nowoczesne aplikacje",
                        modifier = Modifier.color(cm.textMuted)
                    )
                    Br()
                    SpanText(
                        "w Kotlinie.",
                        modifier = Modifier.color(cm.primary)
                    )
                }

                P(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 240)
                        .toAttrs()
                ) {
                    Text(" Tworzę wydajne, natywne rozwiązania na Android, Desktop oraz Web, wykorzystując potęgę współdzielonego kodu. Skaluj swój biznes szybciej z jedną bazą kodu.")
                }

                Row(
                    HeroButtonsStyle.toModifier()
                        .revealFadeSlideUp(isVisible, delayMs = 360),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    PrimaryButton(
                        path = "",
                        text = "Zobacz portfolio",
                        icon = { FaBusinessTime() },
                    )

                    SecondaryButton(
                        path = "",
                        text = "Skontaktuj się",
                        icon = { FaEnvelope() }
                    )
                }
            }
        }

        VisibilityAware(
            modifier = Modifier
                .width(100.percent)
                .overflow(Overflow.Hidden)
                .borderRadius(1.cssRem)
        ) { isVisible ->
            Column(
                modifier = Modifier
                    .width(100.percent)
                    .revealFadeSlideUpScale(
                        isVisible,
                        delayMs = 200,
                        distance = 32.px,
                        fromScale = 0.92
                    ),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center,
            ) {
                Image(
                    "un3.jpg",
                    modifier = Modifier
                        .maxWidth(100.percent)
                        .height(500.px)
                )
            }
        }
    }
}